<script>
  import { HorizontalBar } from 'vue-chartjs'
  import Colors from '../../../mixins/Colors'

  export default {
    extends: HorizontalBar,
    name: 'engagement-summary-graph',
    props: {
      active: {
        type: Boolean,
        required: true
      },
      engagement: {
        type: Object,
        required: true
      }
    },
    mixins: [Colors],
    data () {
      return {
        initiallyRendered: false,
        graphData: []
      }
    },
    methods: {
      renderData () {
        this.initiallyRendered = true
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }

        this.renderChart(
          {
            datasets: [
              {
                data: [this.engagement.HIGH.percentage || 0],
                total: this.engagement.HIGH.count || 0,
                label: 'H',
                backgroundColor: this.ratingColorMap.H,
                hoverBackgroundColor: this.ratingColorMap.H
              },
              {
                data: [this.engagement.GOOD.percentage || 0],
                total: this.engagement.GOOD.count || 0,
                label: 'G',
                backgroundColor: this.ratingColorMap.G,
                hoverBackgroundColor: this.ratingColorMap.G
              },
              {
                data: [this.engagement.PARTIAL.percentage || 0],
                total: this.engagement.PARTIAL.count || 0,
                label: 'P',
                backgroundColor: this.ratingColorMap.P,
                hoverBackgroundColor: this.ratingColorMap.P
              },
              {
                data: [this.engagement.LOW.percentage || 0],
                total: this.engagement.LOW.count || 0,
                label: 'L',
                backgroundColor: this.ratingColorMap.L,
                hoverBackgroundColor: this.ratingColorMap.L
              },
              {
                data: [this.engagement.VERY_LOW.percentage || 0],
                total: this.engagement.VERY_LOW.count || 0,
                label: 'V',
                backgroundColor: this.ratingColorMap.V,
                hoverBackgroundColor: this.ratingColorMap.V
              },
              {
                data: [this.engagement.NONE.percentage || 0],
                total: this.engagement.NONE.count || 0,
                label: 'N',
                backgroundColor: this.ratingColorMap.N,
                hoverBackgroundColor: this.ratingColorMap.N
              }
            ]
          },
          {
            scales: {
              xAxes: [{
                stacked: true,
                scaleLabel: {
                  display: false
                },
                ticks: {
                  min: 0,
                  max: 100,
                  callback: (value) => {
                    return `${value}%`
                  }
                }
              }],
              yAxes: [{
                stacked: true
              }]
            },
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              display: false
            },
            tooltips: {
              mode: 'dataset',
              bodyFontFamily: 'Roboto, sans-serif',
              callbacks: {
                label: (tooltipItem, data) => {
                  let label = data.datasets[tooltipItem.datasetIndex].label || ''

                  if (label) {
                    label += ': '
                  }
                  label += `${tooltipItem.xLabel}%`
                  return label
                },
                afterLabel: (tooltipItem, data) => {
                  const label = data.datasets[tooltipItem.datasetIndex].total || ''
                  return this.$t('days', {day: label}, label)
                }
              }
            }
          })
      }
    },
    computed: {},
    watch: {
      engagement () {
        this.renderData()
      }
    },
    mounted () {
      if (this.active && !this.initiallyRendered) {
        this.renderData()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/student/engagement/EngagementSummaryGraph.vue